module.exports = __webpack_public_path__ + "img/52.d3655445.png";